import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules, productImage } from '../data/content';
import { ProductImageLink } from './CTAButton';
export function ModulesSection() {
  return <section className="bg-white px-4 py-5 sm:px-6" aria-labelledby="solution-heading" data-id="element-95" data-mp="1iv1s77r0bkmm">
      <div className="mb-3 text-center" data-id="element-96" data-mp="1dwqicx0ppa4e">
        <p className="mb-1 text-[11px] font-extrabold uppercase tracking-widest text-brand-green sm:text-xs" data-id="element-97" data-mp="1dxt6wyakb0h5">
          La solution que vous attendiez
        </p>
        <h2 id="solution-heading" className="mb-2 font-heading text-xl uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-98" data-mp="26lfe0gj00n8r">
          Un système complet de planification 6-en-1 pour les coachs de padel
        </h2>
        <p className="mb-2 text-[12px] font-medium leading-snug text-brand-ink sm:text-sm" data-id="element-99" data-mp="1wmgafcd3bhsm">
          Six modules professionnels réunis dans un seul système, conçus pour vous faire gagner du
          temps et simplifier toute votre organisation.
        </p>
        <ProductImageLink src={productImage} alt="Les 6 modules de PADEL COACH READY™" className="mb-2 max-w-[240px] drop-shadow-lg" data-id="element-100" data-mp="1iupaolt8resk" />
        <p className="font-heading text-lg uppercase leading-tight text-brand-navy sm:text-2xl" data-id="element-101" data-mp="1nrz40cjr4alo">
          PADEL COACH READY™
        </p>
        <p className="mb-2 text-[11px] font-bold uppercase tracking-wide text-brand-green sm:text-xs" data-id="element-102" data-mp="1dvcn1yujq3ox">
          Le Système Complet de Planification 6-en-1 pour les Coachs de Padel
        </p>
        <p className="text-[12px] font-medium leading-snug text-brand-ink sm:text-sm" data-id="element-103" data-mp="14vpkvatzstut">
          PADEL COACH READY™ n&apos;est pas simplement une collection d&apos;exercices. C&apos;est un
          système professionnel complet qui vous aide à préparer vos entraînements plus rapidement,
          construire des progressions cohérentes, développer vos joueurs et organiser votre travail
          avec davantage de méthode. Au lieu de repartir de zéro avant chaque entraînement... vous
          ouvrez simplement le système, choisissez les ressources adaptées et commencez votre séance
          avec tout déjà préparé.
        </p>
      </div>
      <div className="mx-auto max-w-xl space-y-2" data-id="element-104" data-mp="2j241artlekcp">
        {modules.map(module => <article key={module.title} className="rounded-lg border border-brand-navy/10 bg-brand-cream p-3 shadow-sm" data-id="element-105" data-mp="2e4vnf3fh92h9">
            <div className="mb-1 flex gap-2" data-id="element-106" data-mp="36tj9h181vvvv">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-green" data-id="element-107" data-mp="36s86v4qccu6c">
                <CheckIcon className="h-3 w-3 text-brand-navy" aria-hidden="true" data-id="element-108" data-mp="31s3pzdlitxfl" />
              </span>
              <h3 className="font-heading text-[13px] uppercase leading-tight text-brand-navy sm:text-base" data-id="element-109" data-mp="2wwoeutewefmv">
                {module.title}
              </h3>
            </div>
            <p className="text-[11px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-110" data-mp="1lgzrw21n9gm2">
              {module.intro}
            </p>
            <ul className="my-1 flex flex-wrap gap-1" data-id="element-111" data-mp="3t1orotqftbml">
              {module.items.map(item => <li key={item} className="rounded border border-brand-navy/10 bg-white px-1.5 py-0.5 text-[10px] font-bold text-brand-navy sm:text-[11px]" data-id="element-112" data-mp="xcoq52hj0uj">
                  {item}
                </li>)}
            </ul>
            <p className="text-[11px] font-semibold leading-snug text-brand-navy sm:text-xs" data-id="element-113" data-mp="fmimdolocj0b">
              {module.outro}
            </p>
          </article>)}
      </div>
    </section>;
}